module.exports = __webpack_public_path__ + "static/media/hamburger_icon.ee4a2bc2.png";